import { render } from "./q2oo_modal.vue?vue&type=template&id=52a22322"
import script from "./q2oo_modal.vue?vue&type=script&lang=js"
export * from "./q2oo_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__